import React from "react";
import { Grid, Theme, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useCommonWidths } from "../../../hooks";
import { MyPageDataTable, MyPagePanel, MyPagePaper } from "../../common";
import { useResource } from "rest-hooks";
import DocumentsResource from "../../../resources/DocumentsResource";
import {
	downloadDocument,
	DownloadDocumentButton,
} from "../../common/DownloadDocumentButton";
import { useSnackbar } from "notistack";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme: Theme) => ({
	panelWrapper: {
		margin: "0 auto",
		maxWidth: 1500,
	},
	paperWrapperMarginTop: {
		marginTop: theme.spacing(2),
	},
	headings: {
		fontWeight: "bold",
	},
	label: {
		fontWeight: "bold",
		color: "grey",
	},
	value: {
		fontWeight: "bold",
	},
}));

interface DocumentsTabPageProps {
	backofficeApplicationId: string | undefined;
}

export const DocumentsTabPage = (props: DocumentsTabPageProps) => {
	const { backofficeApplicationId } = props;
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();
	const isLgUp = useCommonWidths().isLgUp;
	const documents = useResource(DocumentsResource.listShape(), {
		backofficeApplicationId: backofficeApplicationId,
	});

	return (
		<MyPagePanel>
			<Grid item xs={isLgUp ? 6 : 12}>
				<Typography
					variant={isLgUp ? "h4" : "h6"}
					className={classes.headings}
					gutterBottom
				>
					<FormattedMessage
						id="minside.documents_tab_page.header"
						defaultMessage="Avtaledokumenter"
						description="Avtaledokumenter header"
					/>
				</Typography>
				<MyPagePaper className={classes.paperWrapperMarginTop}>
					<MyPageDataTable
						data={documents}
						onRowClick={(e: any, rowData: DocumentsResource) =>
							!isLgUp &&
							downloadDocument({
								setLoading: () => {},
								setResponseCode: () => {},
								enqueueSnackbar: enqueueSnackbar,
								endpoint: `/api/documents/application/${backofficeApplicationId}/${rowData.docID}`,
								filename: rowData.setName,
							})
						}
						columns={[
							{
								title: (
									<FormattedMessage
										id="minside.documents_tab_page.documentName"
										defaultMessage="Dokument"
										description="Dokumentnavn label"
									/>
								),
								field: "setName",
							},
							{
								render: (data: any, row: any) => {
									return (
										<DownloadDocumentButton
											filename={data.setName}
											endpoint={`/api/documents/application/${backofficeApplicationId}/${data.docID}`}
										/>
									);
								},
								headerStyle: { textAlign: "center" },
								field: undefined,
							},
						].map((e: any) => {
							return { cellStyle: { textAlign: "center" }, ...e };
						})}
						options={{
							headerStyle: { textAlign: "center" },
							sorting: false,
						}}
					/>
				</MyPagePaper>
			</Grid>
		</MyPagePanel>
	);
};

export default DocumentsTabPage;
